;(function () {
  'use strict'
  angular.module('obex').factory('socket', [
    '$rootScope',
    function ($rootScope) {
      var socketIo = io()
      return {
        //on: function(event, callback) {
        on: (event, callback) => {
          socketIo.on(event, callback)
        },

        emit: function (eventName, data, callback) {
          socketIo.emit(eventName, data, function () {
            var args = arguments
            if (callback) {
              callback.apply(socketIo, args)
            }
          })
        },

        join: function (room) {
          socketIo.join(room)
        },

        sendClientConnect: function (socketId, loginMember) {
          var space = '  '
          socketIo.emit('client connect', {
            socketId: socketId,
            loginMember: loginMember,
          })
        },

        sendClientDisconnect: function (socketId, loginMember) {
          var space = '  '
          socketIo.emit('client logout', {
            socketId: socketId,
            loginMember: loginMember,
            data: loginMember,
          })
        },
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./client/js/services/socket.service.js